/**
 * Engineering Workspace Chrome — binds clock phase to route around page content.
 * The empty "Engineering timeline / No runtime events yet" strip was removed —
 * mission activity lives on the progress header and Overview timeline instead.
 */

import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { phaseFromPathname, useEngineeringClock } from '../engineeringClockStore';

export interface EngineeringWorkspaceChromeProps {
  children: React.ReactNode;
  /** @deprecated Timeline chrome removed; kept for call-site compatibility. */
  showTimeline?: boolean;
}

export const EngineeringWorkspaceChrome: React.FC<EngineeringWorkspaceChromeProps> = ({
  children,
}) => {
  const location = useLocation();
  const setPhase = useEngineeringClock((s) => s.setPhase);

  useEffect(() => {
    setPhase(phaseFromPathname(location.pathname));
  }, [location.pathname, setPhase]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minHeight: '100%',
        height: '100%',
        flex: 1,
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
};

export default EngineeringWorkspaceChrome;
